export default {"src":"/_next/static/media/discord.9f8629dd.svg","height":512,"width":512};